import { useState } from 'react';
import DangerIcon from '../../../assets/icons/danger.svg?react';
import { useDeleteStation } from '../../../hooks/queries/stationQueries';

const StationDeleteModal = ({onClose, station, onDeleteSuccess}) => {
  // React Query mutation 훅을 컴포넌트 최상위 레벨에서 호출
  const deleteStationMutation = useDeleteStation();

  const handleDelete = async () => {
    try {
      // 여러 충전소를 삭제하는 경우
      const deletePromises = [deleteStationMutation.mutateAsync(station.StationSysId)];
      await Promise.all(deletePromises);
      onDeleteSuccess(); // 삭제 성공 시 콜백 호출
      onClose();
    } catch (error) {
      console.error('충전소 삭제 실패:', error);
      alert('충전소 삭제에 실패했습니다.');
    }
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header flex-col gap-10">
          <DangerIcon className='text-error'/>
          <h3>충전소를 삭제하시겠습니까?</h3>
        </div>
        <div className="modal-content">
          <table className='gray-table'>
            <tr>
              <th>충전소 식별자</th>
              <td>{station.CpoStationId || "-"}</td>
            </tr>
            <tr>
              <th>충전소 주소</th>
              <td>{station.Address || "-"}</td>
            </tr>
            <tr>
              <th>충전사업자</th>
              <td>{station.CpoName || "-"}</td>
            </tr>
            <tr>
              <th>충전사업자 식별자</th>
              <td>{station.CpoId || "-"}</td>
            </tr>
            <tr>
              <th>계량기 계약번호</th>
              <td>{station.PowerMeterContractNumber || "-"}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 btn-style-5" onClick={onClose}>취소</button>
          <button 
            className="btn py-5 px-10 btn-primary" 
            onClick={handleDelete}
            disabled={deleteStationMutation.isPending}
          >
            {deleteStationMutation.isPending ? '삭제 중...' : '삭제하기'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default StationDeleteModal